import { useReducer } from "react"
import { db, Timestamp } from "../firebase/FirebaseConfig";
import { addDoc, collection, doc, deleteDoc, updateDoc, writeBatch } from "firebase/firestore";

let initialState = {
  document: null,
  isPending: false,
  error: null,
  success: null
}

const firestoreReducer = (state, action) => {
  switch (action.type) {
    case 'IS_PENDING':
      return { isPending: true, document: null, success: false, error: null }
    case 'ADDED_DOCUMENT':
      return { isPending: false, document: action.payload, success: true, error: null }
    case 'DELETED_DOCUMENT':
      return { isPending: false, document: null, success: true, error: null }
    case 'UPDATED_DOCUMENT':
      return { isPending: false, document: action.payload, success: true, error: null }
    case 'ERROR':
      return { isPending: false, document: null, success: false, error: action.payload }
    case 'BATCH_DOCUMENTS' :
      return { isPending: false, document: action.payload, success: true, error: null}
    default:
      return state
  }
}

export const useFirestore = (collectionPath) => {
  const [response, dispatch] = useReducer(firestoreReducer, initialState)

  // collection ref
  const ref = collection(db, collectionPath)

  // add a document
  const addDocument = async (doc) => {
    dispatch({ type: 'IS_PENDING' })

    try {
      const createdAt = Timestamp.fromDate(new Date())
      const addedDocument = await addDoc(ref, { ...doc, createdAt })
      dispatch({ type: 'ADDED_DOCUMENT', payload: addedDocument })
    }
    catch (err) {
      dispatch({ type: 'ERROR', payload: err.message })
    }
  }

  // delete a document
  const deleteDocument = async (id) => {
    dispatch({ type: 'IS_PENDING' })

    try {
      await deleteDoc(doc(db, collectionPath, id ))
      dispatch({ type: 'DELETED_DOCUMENT' })
    }
    catch (err) {
      dispatch({ type: 'ERROR', payload: 'could not delete' })
    }
  }

  //update a document
  const updateDocument = async (id, updates) => {
    dispatch({ type: 'IS_PENDING'})

    try {
      const docRef = doc(db, collectionPath, id)
      const updatedDocument = await updateDoc(docRef, updates)
      dispatch({ type: 'UPDATED_DOCUMENT', payload: updatedDocument})
      return updatedDocument
    } catch (err) {
      dispatch({ type: 'ERROR', payload: err.message })
      console.error(err)
      return null
    }
  }

  //batch documents
  const batchDocuments = async (toAdd, toUpdate, toDelete) => {
    dispatch({ type: 'IS_PENDING'})

    
    try {
      //Do the batch !
      const batch = writeBatch(db)
      //CREATE
      if (toAdd?.length > 0) {
        toAdd.forEach(addedTask => {
          let docRef = doc(collection(db, collectionPath))
          batch.set(docRef, addedTask)
        });
      }

      //UPDATE
      if (toUpdate?.length > 0) {
        toUpdate.forEach(updatedTask => {
          let docRef = doc(db, collectionPath, updatedTask.id)
          batch.update(docRef, updatedTask.updates)
        });
      }

      //DELETE
      if (toDelete?.length > 0) {
        toDelete.forEach(deletedTask => {
          let docRef = doc(db, collectionPath, deletedTask.id)
          batch.delete(docRef)
        });
      }

      const commit = await batch.commit()
      dispatch({ type: 'BATCH_DOCUMENTS', payload: commit})
      
    } catch (error) {
      console.error(error)
      dispatch({ type: 'ERROR', payload: error.message})
    }


  }


  return { addDocument, deleteDocument, updateDocument, batchDocuments, response }

}
